import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import type { CSSProperties } from 'react';

import { APP_VERSION } from '@/utils/version';

interface AppVersionProps {
  /** Override container styles, e.g. to adjust alignment or margin. */
  style?: CSSProperties;
}

/**
 * Dumb presentational component — displays the application version discreetly.
 *
 * Reads APP_VERSION from src/utils/version.ts (injected at build via VITE_APP_VERSION).
 * Renders as secondary antd Typography.Text at ~12 px.
 * Uses i18n for the accessible aria-label — no hardcoded strings.
 */
export default function AppVersion({ style }: AppVersionProps) {
  const { t } = useTranslation('common');

  return (
    <Typography.Text
      type="secondary"
      aria-label={t('appVersion')}
      style={{ fontSize: 12, ...style }}
    >
      v{APP_VERSION}
    </Typography.Text>
  );
}
